import React from 'react';

function PrivacyPolicy() {
  return (
    <div style={{ 
      backgroundColor: '#0a0e1a',
      minHeight: '100vh',
      padding: '60px'
    }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '40px' }}>
          <h1 style={{ 
            fontSize: '42px',
            fontWeight: '800',
            margin: '0 0 15px 0',
            color: '#ffffff',
            letterSpacing: '-0.5px'
          }}>
            Privacy Policy
          </h1>
          <p style={{ 
            fontSize: '14px',
            color: '#64748b',
            margin: 0
          }}>
            Last Updated: February 20, 2026
          </p>
        </div>

        {/* Content */}
        <div style={{
          backgroundColor: '#1a1f2e',
          border: '1px solid #2d3748',
          borderRadius: '12px',
          padding: '40px',
          color: '#a0aec0',
          fontSize: '15px',
          lineHeight: '1.8'
        }}>
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>1. Introduction</h2>
            <p style={{ marginBottom: '15px' }}>
              Upperline Solutions LLC ("Upperline Bet," "we," "us," or "our") operates upperlinebet.com 
              (the "Service"). This Privacy Policy explains how we collect, use, disclose, and safeguard 
              your information when you use our Service.
            </p>
            <p style={{ marginBottom: '15px'}}>
              This Service is intended for residents of the United States only. We do not knowingly provide 
              services to residents of the European Economic Area (EEA) or United Kingdom, and this Privacy 
              Policy is not designed to comply with GDPR or UK GDPR.
            </p>
            <p style={{ marginBottom: '15px' }}>
              <strong>Contact Information:</strong><br />
              Upperline Solutions LLC<br />
              Boston, MA<br />
              Email: legal@upperlinebet.com
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>2. Information We Collect</h2>
            
            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>2.1 Information You Provide</h3>
            <p style={{ marginBottom: '15px' }}>
              We collect information you provide directly to us:
            </p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li>Account information (name, email address, password)</li>
              <li>Payment information (processed securely through Stripe - we do not store credit card numbers)</li>
              <li>Contact form submissions (name, email, message content)</li>
              <li>Communications with our support team</li>
            </ul>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>2.2 Automatically Collected Information</h3>
            <p style={{ marginBottom: '15px' }}>
              When you use our Service, we automatically collect:
            </p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li>IP address and approximate location</li>
              <li>Browser type and version</li>
              <li>Device information</li>
              <li>Pages visited and features used</li>
              <li>Date and time of visits</li>
              <li>Referring website addresses</li>
            </ul>

            <h3 style={{ color: '#ffffff', fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>2.3 Cookies and Tracking</h3>
            <p style={{ marginBottom: '15px' }}>
              We use cookies and similar tracking technologies. The types of cookies we may use include:
            </p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li><strong>Strictly Necessary Cookies:</strong> Required for the Service to function 
              (authentication, session management, security). These cannot be disabled.</li>
              <li><strong>Analytics Cookies:</strong> Used to understand how visitors use our Service 
              (e.g., pages visited, features used). We will disclose specific analytics tools here when 
              they are implemented and obtain appropriate consent before setting non-essential cookies.</li>
              <li><strong>Preference Cookies:</strong> Used to remember your settings and preferences.</li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              You can instruct your browser to refuse all cookies or to alert you when cookies are being set. Refusing cookies may affect the functionality of the Service. We will update this section and implement a cookie consent mechanism before deploying any third-party analytics or marketing tracking tools.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>3. How We Use Your Information</h2>
            <p style={{ marginBottom: '15px' }}>We use collected information for:</p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li>Providing and maintaining our Service</li>
              <li>Processing your subscription payments</li>
              <li>Sending you account-related communications</li>
              <li>Responding to your inquiries and support requests</li>
              <li>Detecting and preventing fraud and abuse</li>
              <li>Analyzing usage patterns to improve our Service</li>
              <li>Enforcing our Terms of Service</li>
              <li>Complying with legal obligations</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>4. Third-Party Service Providers</h2>
            <p style={{ marginBottom: '15px' }}>We share your information with third-party service providers who perform services on our behalf:</p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li><strong>Stripe:</strong> Payment processing (subject to Stripe's privacy policy)</li>
              <li><strong>Clerk:</strong> Authentication and user management</li>
              <li><strong>Resend:</strong> Transactional email delivery</li>
              <li><strong>Hosting Provider:</strong> Infrastructure and data storage</li>
              <li><strong>Analytics Services:</strong> Usage analytics (if applicable)</li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              These providers are contractually obligated to use your information only as necessary to provide 
              services to us and are prohibited from using it for their own purposes.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>5. Data Retention</h2>
            <p style={{ marginBottom: '15px' }}>
              We retain your personal information for as long as your account is active or as needed to 
              provide you services. After account deletion, we retain certain information for up to one (1) 
              year for fraud prevention, legal compliance, and to prevent abuse of free trial periods.
            </p>
            <p style={{ marginBottom: '15px' }}>
              Payment records are retained for seven (7) years to comply with tax and financial regulations.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>6. Your Rights</h2>
            <p style={{ marginBottom: '15px' }}>Depending on your state of residence, you may have some or all 
              of the following rights regarding your personal information:</p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li><strong>Access:</strong> Request a copy of the personal information we hold about you</li>
              <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
              <li><strong>Deletion:</strong> Request deletion of your personal information, subject to legal 
              retention requirements</li>
              <li><strong>Portability:</strong> Request transfer of your data in a machine-readable format</li>
              <li><strong>Opt-out of Marketing:</strong> Unsubscribe from promotional communications at any time</li>
              <li><strong>Restriction:</strong> Request that we limit how we process your information</li>
              <li><strong>Sensitive Information:</strong>  Request that we limit use of sensitive personal 
              information (California CPRA)</li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              Residents of California, Virginia, Colorado, Connecticut, Texas, Oregon, Montana, and other 
              states with active consumer privacy laws may exercise these rights by contacting us at 
              legal@upperlinebet.com. We will respond within 30 days. We will not discriminate against 
              you for exercising any of these rights.
            </p>
            <p style={{ marginBottom: '15px' }}>
              We do not sell your personal information to third parties.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>7. Data Security</h2>
            <p style={{ marginBottom: '15px' }}>
              We implement appropriate technical and organizational security measures to protect your 
              information against unauthorized access, alteration, disclosure, or destruction. However, 
              no method of transmission over the Internet or electronic storage is 100% secure.
            </p>
            <p style={{ marginBottom: '15px' }}>
              We use industry-standard encryption (SSL/TLS) for data transmission and secure our databases 
              with access controls and encryption at rest.
            </p>
            <p style={{ marginBottom: '15px' }}>
              In the event of a data breach that affects your personal information, we will notify you via 
              email at the address associated with your account within 72 hours of becoming aware of the 
              breach, or as soon as reasonably practicable. Notification will include the nature of the breach, 
              the information affected, and steps we are taking to address it, in accordance with applicable 
              state breach notification laws.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>8. Children's Privacy</h2>
            <p style={{ marginBottom: '15px' }}>
              Our Service is not intended for individuals under 18 years of age. We do not knowingly collect 
              personal information from children under 18. If you become aware that a child has provided us 
              with personal information, please contact us immediately.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>9. California Privacy Rights (CCPA/CRPA)</h2>
            <p style={{ marginBottom: '15px' }}>
              California residents have additional rights under the California Consumer Privacy Act (CCPA) 
              as amended by the California Privacy Rights Act (CPRA):
            </p>
            <ul style={{ marginLeft: '20px', marginBottom: '15px' }}>
              <li>Right to know what personal information is collected, used, shared, or sold</li>
              <li>Right to delete personal information we hold about you</li>
              <li>Right to correct inaccurate personal information</li>
              <li>Right to opt out of the sale or sharing of personal information</li>
              <li>Right to limit use and disclosure of sensitive personal information</li>
              <li>Right to non-discrimination for exercising your privacy rights</li>
            </ul>
            <p style={{ marginBottom: '15px' }}>
              <strong>Sensitive Personal Information:</strong> We may collect information that qualifies as 
              sensitive personal information under CPRA, including payment information and account credentials. 
              We use this information only as necessary to provide the Service and do not use it to infer 
              characteristics about you.
            </p>
            <p style={{ marginBottom: '15px' }}>
              <strong>We do not sell your personal information.</strong> We do not share your personal information 
              with third parties for cross-context behavioral advertising.
            </p>
            <p style={{ marginBottom: '15px' }}>
              To exercise your California rights, contact us at legal@upperlinebet.com.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>10. Geographic Scope</h2>
            <p style={{ marginBottom: '15px' }}>
              This Service is operated from the United States and is intended for U.S. residents only. All data 
              we collect is stored and processed on servers located in the United States. By using the Service, 
              you acknowledge that your information will be processed in the United States in accordance with this 
              Privacy Policy and applicable U.S. law.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>11. Changes to This Privacy Policy</h2>
            <p style={{ marginBottom: '15px' }}>
              We may update this Privacy Policy from time to time. We will notify you of any changes by 
              posting the new Privacy Policy on this page and updating the "Last Updated" date. Material 
              changes will be communicated via email.
            </p>
            <p style={{ marginBottom: '15px' }}>
              Your continued use of the Service after changes are posted constitutes acceptance of the 
              updated Privacy Policy.
            </p>
          </section>

          <section>
            <h2 style={{ color: '#ffffff', fontSize: '24px', marginBottom: '15px' }}>12. Contact Us</h2>
            <p style={{ marginBottom: '15px' }}>
              If you have questions about this Privacy Policy, please contact us:
            </p>
            <p style={{ marginBottom: '5px' }}>
              Email: legal@upperlinebet.com<br />
              Address: Upperline Solutions LLC, Boston, MA
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;